// @flow
export { default } from './QuestionModal';



// WEBPACK FOOTER //
// ./src/components/common/QuestionModal/index.js